module.exports = "../fonts/link.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link.svg
// module id = 427
// module chunks = 0